// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://hospitalwebsite-production.up.railway.app'
    : 'http://localhost:5000');

export const API_ENDPOINTS = {
  units: `${API_URL}/api/units`,
  singleUnit: (id: string) => `${API_URL}/api/units/${id}`,
  login: `${API_URL}/api/login`,
  health: `${API_URL}/api/health`,
};




